import requestModule from '@/application/libs/requestModule'
import util from  '@/application/libs/util'

const _getNRORG = () => util.getLocalVar('userData').NRORG
const defaultResponseHandler = (response) => {
    if(!response.error){
        return response.dataset && response.dataset.data;
    } else {
        throw response;
    }
};

const defaultErrorResponseHandler = (responseError) => {
    let returnError = {};
    if(responseError.errorCode !== 0){
        returnError = responseError;
    }
    return returnError;
};

export default {
    getAccessProfiles(){
        return requestModule.postRequest('getData', {
            FROM: "ACCESS_PROFILE",
            PARAMS: {
                NRORG: _getNRORG(),
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getAccessProfilesPermissions(NRPERFILACESSO) {
        return requestModule.postRequest('getData', {
            FROM: "ACCESS_PROFILE_PERMISSION",
            PARAMS: {
                NRORG: _getNRORG(),
                NRPERFILACESSO
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    getUsersByAccessProfile(NRPERFILACESSO) {
        return requestModule.postRequest('getData', {
            FROM: "USERS_BY_ACCESS_PROFILE",
            PARAMS: {
                NRORG: _getNRORG(),
                NRPERFILACESSO
            }
        }).then(response=>response.dataset && response.dataset.data);
    },

    saveAccessProfilePermission(NRPERFILACESSO, NROTIMIZADORITEM){
        return requestModule.postRequest('insertData', {
            FROM: "ACCESS_PROFILE_PERMISSION",
            PARAMS: [{
                NRPERFILACESSO,
                NROTIMIZADORITEM,
                NRORG: _getNRORG()
            }],
        }).then(defaultResponseHandler).
        catch(defaultErrorResponseHandler)    
    },

    removeAccessProfilePermission(NROTIMIZADORITEMPER){
        return requestModule.postRequest('deleteData', {
            FROM: "ACCESS_PROFILE_PERMISSION",
            PARAMS: [{
                NROTIMIZADORITEMPER,
                NRORG: _getNRORG()
            }],
        }).then(defaultResponseHandler).
        catch(defaultErrorResponseHandler)   
    },

    // TODO, change variable names to server side params
    grantAllPermissionToAccessProfile(NRPERFILACESSO, NROTIMIZADORITEM, QUANTIDADE){
        // return Promise.resolve();
        return requestModule.postRequest('insertData', {
            FROM: "ACCESS_PROFILE_PERMISSION_BULK",
            PARAMS: [{
                NRPERFILACESSO,
                NROTIMIZADORITEM,
                QUANTIDADE,
                NRORG: _getNRORG()
            }],
        }).then(defaultResponseHandler).
        catch(defaultErrorResponseHandler)   
    },

    revokeAllPermissionToAccessProfile(NROTIMIZADORITENSSTR){
        return requestModule.postRequest('deleteData', {
            FROM: "ACCESS_PROFILE_PERMISSION_BULK",
            PARAMS: [{
                NROTIMIZADORITENSSTR,
                NRORG: _getNRORG()
            }],
        }).then(defaultResponseHandler).
        catch(defaultErrorResponseHandler)   
    }

}